
<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '标题',
  },
  showHeaderBottomBorder: {
    type: Boolean,
    default: false
  }
})
const emits = defineEmits(['update:modelValue', 'close'])

const showModal = computed({
  get() {
    return props.modelValue
  },
  set(value: boolean) {
    emits('update:modelValue', value)
  },
})
function onClose() {
  emits('close')
  emits('update:modelValue', false)
}

</script>

<template>
  <NModal v-model:show="showModal" :mask-closable="false" :close-on-esc="false">
    <div class="company-basic-modal" :class="[showHeaderBottomBorder ? 'has-bottom-border' : '']">
      <div class="header">
        <div class="title">{{ title }}</div>
        <div class="close" @click="onClose">
          <div class="icon"></div>
        </div>
      </div>
      <div class="content">
        <slot />
      </div>
      <div class="footer" v-if="$slots.footer">
        <slot name="footer" />
      </div>
    </div>
  </NModal>
</template>

<style lang="scss">
.company-basic-modal {
  min-width: 500px;
  background-color: #fff;
  border-radius: 8px;

  &.has-bottom-border {
    .header {
      padding: 24px 24px 20px;
      border-bottom: 1px solid #E6E6E6;
    }

    .content {
      padding: 20px 24px 24px;
    }
  }

  .header {
    padding: 24px;
    position: relative;


    .title {
      font-size: 16px;
      color: #242F57;
      font-weight: 500;
    }

    .close {
      position: absolute;
      top: 16px;
      right: 10px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .icon {
        width: 20px;
        height: 20px;
        background-image: url('./close.png');
        background-size: 100%;
      }
    }
  }

  .content {
    padding: 0 24px 24px;
  }

  .footer {
    padding: 0 24px 24px;

    .footer-btn {
      width: 92px;
      height: 32px;
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
      overflow: hidden;
    }

    .cancel-btn {
      border: 1px solid #C4C8CC;
    }
  }
}
</style>
